import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);
const GetRequest = () => {
    let url = decodeURI(location.search); //获取url中"?"符后的字串
    let theRequest = new Object();
    if (url.indexOf("?") != -1) {
        let str = url.substr(1);
        let strs = str.split("&");
        for(let i = 0; i < strs.length; i ++) {
            theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}

export default new Router({
    mode: 'abstract', // abstract
    base: process.env.BASE_URL,
	routes: [
		{
			path: "/",
			redirect: "/index",
			// redirect: "/ceshi",
        },
        {
			path: "/ceshi",
			component: resolve => require(['@/views/ceshi'],resolve),
			name: "ceshi"
        },
		{
			path: "/index",
			component: resolve => require(['@/views/index'],resolve),
			name: "index"
        },
        {
			path: "/tuceList",
			component: resolve => require(['@/views/tuceList'],resolve),
			name: "tuceList"
        },
        {
			path: "/tuce",
			component: resolve => require(['@/views/tuce'],resolve),
			name: "tuce"
        },
        {
			path: "/map",
			component: resolve => require(['@/views/map'],resolve),
			name: "map"
        },
        { // 京山印象
            path: "/impression",
            component: resolve => require(['@/views/secondLevelPage/impression'],resolve),
            name: "impression",
        },
        { // 全景
            path: "/panorama",
            component: resolve => require(['@/views/panorama'],resolve),
            name: "panorama",
        },
        { // 千年惊叹/非遗京韵 详情
            path: "/millenniumDetails",
            component: resolve => require(['@/views/details/millenniumDetails'],resolve),
            name: "millenniumDetails"
        },
        { // 美食/人杰 详情
            path: "/foodDetails",
            component: resolve => require(['@/views/details/foodDetails'],resolve),
            name: "foodDetails"
        },
        { // 路线详情
            path: "/routerDetails",
            component: resolve => require(['@/views/details/routerDetails'],resolve),
            name: "routerDetails"
        },
        { // 印象详情
            path: "/impressionDetails",
            component: resolve => require(['@/views/details/impressionDetails'],resolve),
            name: "impressionDetails"
        },
        {
            path: "/secondLevelPage",
			component: resolve => require(['@/views/secondLevelPage'],resolve),
            name: "secondLevelPage",
            children: [
                { // 千年京叹
                    path: "/jingtan",
                    component: resolve => require(['@/views/secondLevelPage/humanities/jingtan'],resolve),
                    name: "jingtan",
                },
                { // 特色京味
                    path: "/food",
                    component: resolve => require(['@/views/secondLevelPage/humanities/food'],resolve),
                    name: "food",
                },
                { // 非遗京韵
                    path: "/feiyi",
                    component: resolve => require(['@/views/secondLevelPage/humanities/feiyi'],resolve),
                    name: "feiyi",
                },
                { // 人杰京山
                    path: "/renjie",
                    component: resolve => require(['@/views/secondLevelPage/humanities/renjie'],resolve),
                    name: "renjie",
                },
                { // 主要景区
                    path: "/ScenicArea",
                    component: resolve => require(['@/views/secondLevelPage/swimFreely/ScenicArea'],resolve),
                    name: "ScenicArea",
                },
                { // 乡村旅游
                    path: "/rural",
                    component: resolve => require(['@/views/secondLevelPage/swimFreely/rural'],resolve),
                    name: "rural",
                },
                { // 红色旅游
                    path: "/redTourism",
                    component: resolve => require(['@/views/secondLevelPage/swimFreely/redTourism'],resolve),
                    name: "redTourism",
                },
                { // 夜游京山
                    path: "/night",
                    component: resolve => require(['@/views/secondLevelPage/swimFreely/night'],resolve),
                    name: "night",
                },
                { // 路线攻略
                    path: "/route",
                    component: resolve => require(['@/views/secondLevelPage/swimFreely/route'],resolve),
                    name: "route",
                },
                { // 酒店
                    path: "/hotel",
                    component: resolve => require(['@/views/secondLevelPage/PlayAround/hotel'],resolve),
                    name: "hotel",
                },
                { // 民宿
                    path: "/homestay",
                    component: resolve => require(['@/views/secondLevelPage/PlayAround/homestay'],resolve),
                    name: "homestay",
                },
                { // 餐厅
                    path: "/restaurant",
                    component: resolve => require(['@/views/secondLevelPage/PlayAround/restaurant'],resolve),
                    name: "restaurant",
                },
                { // 购物
                    path: "/shopping",
                    component: resolve => require(['@/views/secondLevelPage/PlayAround/shopping'],resolve),
                    name: "shopping",
                },
                { // 出行
                    path: "/travel",
                    component: resolve => require(['@/views/secondLevelPage/PlayAround/travel'],resolve),
                    name: "travel",
                }
            ]
            
        }
	]
})

